import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import Antd from "ant-design-vue";
import moment from "moment";
import { logout } from "@/api/login";

import "ant-design-vue/dist/antd.css";
import "@/styles/reset.css";
import "@/styles/common.css";

Vue.use(Antd);
Vue.config.productionTip = false;
Vue.prototype.$moment = moment;
Vue.prototype.checkoutHtml = (str) => {
  return str?.replace(/\n/g, "<br/>") || "";
};

// 定义全局监听逻辑
const setupIdleLogout = () => {
  const idleTime = 30 * 60 * 1000; // 30分钟无操作
  let timeout;

  // 执行登出操作
  const handleLogout = () => {
    logout() // 调用登出接口
      .then(() => {
        store.dispatch("updateUserInfo", null); // 清空用户信息
        store.dispatch("updateMessageCount", null); // 清空消息数量
        const history = window.top.location.href;
        if (history.indexOf("online-review") > -1) {
          window.top.location.href = "/#/login-online-review";
        } else {
          window.top.location.href = process.env.VUE_APP_IXIAMEN_URL; // 跳转到登录页
        }
        Vue.prototype.$message.warning("您已长时间未操作，请重新登录"); // 提示信息
      })
      .catch((error) => {
        console.error("登出失败", error);
        Vue.prototype.$message.error("退出登录失败，请稍后重试");
      });
  };

  // 重新计时函数
  const resetTimer = () => {
    const currentPath = router.currentRoute.fullPath;
    if (
      currentPath &&
      (currentPath.includes("/online-review") ||
        currentPath.startsWith("/mobile"))
    ) {
      clearTimeout(timeout);
      timeout = null;
      return;
    }
    clearTimeout(timeout);
    console.log("重新计时");
    timeout = setTimeout(() => {
      handleLogout();
    }, idleTime);
  };

  // 监听用户操作的事件
  const events = ["mousemove", "keydown", "click", "scroll"];
  events.forEach((event) => window.addEventListener(event, resetTimer));

  resetTimer(); // 初始化计时器
};

new Vue({
  router,
  store,
  render: (h) => h(App),
  mounted() {
    setupIdleLogout(); // 应用挂载后启动全局监听
  },
}).$mount("#app");
